<nb-card>
    <nb-card-header class="header">{{ 'quote_part.distribution_key' | translate }}</nb-card-header>
    <nb-card-body>
        <form [formGroup]="repartitionForm" autocomplete="off">
            <!-- Name and Archive Checkbox -->
            <div class="form-group">
                <div class="input-group-line">
                    <label class="align-self-baseline margin-right-30 font-weight-bold white-space-no-wrap key-name"
                           for="keyName">{{
                            'quote_part.key_name' |
                                translate
                        }}</label>
                    <div class="form-control-group">
                        <input nbInput fullWidth id="keyName" formControlName="name" [required]="true"
                               [attr.aria-invalid]="repartitionForm.get('name').invalid && repartitionForm.get('name').touched ? true : null"
                               placeholder="{{'quote_part.key_name' | translate}}"/>
                        @if (repartitionForm.get('name').invalid && repartitionForm.get('name').touched) {
                            @if (repartitionForm.get('name').errors?.required) {
                                <p class="caption text-danger pt-2">
                                    {{ 'quote_part.required_name' | translate }}
                                </p>
                            }
                        }
                    </div>
                </div>
            </div>

            <!-- Table for Distribution -->
            <div class="flex flex-column">
                <div class="distribution-title pb-3">{{ 'quote_part.distribution' | translate }}</div>
                <div class="distribution-wrapper">
                    <table class="distribution-table">
                        <thead>
                        <tr >
                            <th style="width: 40%">
                                    <span>
                                        <input class="color-input" type="color" formControlName="color_code"
                                               [disabled]="readOnly">
                                    </span>
                                <span class="color-label">{{ 'quote_part.color_code' | translate }}</span>
                            </th>
                            <th style="width: 12%">%</th>
                            <th style="width: 13%">{{ 'quote_part.property_code' | translate }}</th>
                            <th>{{ 'Label' | translate }} {{
                                    'quote_part.property_code' |
                                        translate
                                }}
                            </th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody formArrayName="distribution">
                            @for (item of distributionControls.controls; track item; let i = $index) {
                                <tr [formGroupName]="i">
                                    <td>
                                        <nb-select formControlName="sponsor_id"
                                                   style="width: 100%; min-width: 150px; max-width: none"
                                                   [status]="submitted && item.get('sponsor_id').invalid ? 'danger' : 'basic'">
                                            @for (option of investmentSponsors; track option) {
                                                <nb-option [value]="option.id"
                                                           [disabled]="isOptionSelected(option.id)"
                                                >
                                                    {{ option.name }}
                                                </nb-option>
                                            }
                                        </nb-select>
                                    </td>
                                    <td>
                                        <input class="quote-part-percentage" nbInput fullWidth
                                               formControlName="percentage"
                                               type="number" min="1" max="100"/>
                                    </td>
                                    <td>
                                        <input nbInput fullWidth formControlName="property_code"/>
                                    </td>
                                    <td>
                                        <input nbInput formControlName="property_code_label" style="width: 100%; max-width: 100%">
                                    </td>
                                    <td>
                                      <a href="#"><i [style.visibility]="i !== 0 && !readOnly && isCreating ? 'visible' : 'hidden'"
                                           class="fa-thin fa-trash-can icon-gray font-size-18 "
                                           (click)="removePart(i)"></i></a>
                                    </td>

                                </tr>
                            }
                        <tr>
                            <td class="text-left">
                                <span style="padding-left: 14px">Total</span>
                            </td>
                            <td class="text-right">
                                <span>{{ getTotalPercentage() }}</span>
                            </td>
                            <td style="border: 1px solid #ccc"></td>
                            <td style="border: 1px solid #ccc"></td>
                        </tr>
                        </tbody>
                    </table>
                    <a class="add-new-btn pe-auto btn" *ngIf="!readOnly && isCreating"
                       (click)="addRow()">{{ 'quote_part.add_new_line' | translate }}</a>
                </div>
            </div>

            <!-- Parent and Child Checkboxes -->
            <h5 class="mt-3 font-size-14">{{ 'quote_part.perimeter' | translate }}</h5>

            <!--parents checkbox for Périmètres-->
            <div class="type-perimeter">
                <div formArrayName="perimeters" class="margin-bottom-20">
                    <label class="title mb-3">{{ 'quote_part.perimeter_list' | translate }}</label>
                    <div class="checkbox-children">
                        @for (control of perimeterControls.controls; track control; let i = $index) {
                            <div [formGroupName]="i" class="margin-bottom-10">
                                <nb-checkbox formControlName="checked">
                                    <label class="text">{{ control?.value?.name }}</label>
                                </nb-checkbox>
                            </div>
                        }
                    </div>
                  <p>* {{'A perimeter can only have one distribution key indicated by default' | translate}}</p>
                </div>
            </div>

            <!-- Refundability -->
            <h5 class="mt-2 font-size-14">{{ 'quote_part.rebilling_default' |translate }}</h5>
            <nb-radio-group formControlName="refacturable" class="refacturable">
                <nb-radio class="font-weight-normal" value="true">{{ 'quote_part.rebbillable' |translate }}</nb-radio>
                <nb-radio class="font-weight-normal" value="false">{{ 'quote_part.non_rebillable' |translate }}
                </nb-radio>
                <nb-radio class="font-weight-normal" value="null">{{ 'quote_part.unknown' |translate }}</nb-radio>
            </nb-radio-group>
        </form>
    </nb-card-body>
    <nb-card-footer>
      <button nbButton (click)="close()" class="me-3">{{ 'Cancel' | translate }}</button>
        <button nbButton (click)="confirmOK()"
                [disabled]="!isUpdateBtnEnabled || (submitted && !isFormValid)">{{ 'OK' | translate }}
        </button>
    </nb-card-footer>
</nb-card>
